import { AxiosResponse } from "axios";

export enum DownloadType {
  Excel = "application/excel",
  Zip = "application/zip",
  Pdf = "application/pdf",
}

export function downloadFile(
  response: AxiosResponse,
  options?: {
    downloadType?: DownloadType | string;
  }
) {
  const { downloadType = DownloadType.Excel } = options || {};

  let filename = "";

  const disposition = response.headers["content-disposition"];

  if (disposition && disposition.indexOf("attachment") !== -1) {
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = filenameRegex.exec(disposition);
    if (matches != null && matches[1]) {
      filename = decodeURI(matches[1].replace(/['"]/g, ""));
    }
  }
  const a = document.createElement("a");
  document.body.appendChild(a);

  a.setAttribute("style", "display: none");
  const blob = new Blob([response.data], { type: downloadType });
  if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
    (window.navigator as any).msSaveOrOpenBlob(blob, filename);
  } else {
    const url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  }
  document.body.removeChild(a);
}
